export default __webpack_public_path__ + "static/media/exportLogo.33be463c.svg";